<vx-otp-input
  [formControl]="step().code"
  [invalid]="step().invalid()"
  [verifying]="step().verifying()"
  [disabled]="isDisabled()"
  [ariaLabel]="ariaLabel() ?? ('pages.auth.code.inputLabel' | transloco)"
  (completed)="completed.emit($event)" />

<div class="mt-4 flex min-h-5 flex-col items-center gap-1 text-center">
  @if (step().verifying()) {
    <p
      class="flex animate-fade items-center gap-1.5 text-13 tracking-tight text-zinc-400 animate-duration-200 motion-reduce:animate-none"
      role="status">
      <vx-icon
        name="circle-notch"
        size="sm"
        class="animate-spin motion-reduce:animate-none" />
      {{ 'pages.auth.code.verifying' | transloco }}
    </p>
  } @else if (messages().length) {
    <app-kratos-messages [messages]="messages()" />
  }
</div>
